"use strict";
module.exports = ['$translate', '$http', '$httpParamSerializer', 'ngDroUAACommon', function ($translate, $http, $httpParamSerializer, ngDroUAACommon) {

        this.findOne = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix (usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/role/' + id)
            });
        };

        this.findAll = function (usePrefix) {
            ngDroUAACommon.setUsePrefix (usePrefix || true);
            
            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/role')
            });
        };
        
        this.findAllPerms = function (usePrefix) {
            ngDroUAACommon.setUsePrefix (usePrefix || true);
            
            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/role/perms')
            });
        };
        
        this.delete = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix (usePrefix || true);
            
            return $http({
                method: 'DELETE',
                url: ngDroUAACommon.getUrl('api/role/' +id),
                withCredentials: true
            });
        };
        
        this.save = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix (usePrefix || true);

            return $http({
                method: 'POST',
                url: ngDroUAACommon.getUrl('api/role'),
                withCredentials: true,
                data: params
            });
        };
        
        this.update = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix (usePrefix || true);

            return $http({
                method: 'PUT',
                url: ngDroUAACommon.getUrl('api/role'),
                withCredentials: true,
                data: params
            });
        };
        
        return {
            findAll: this.findAll,
            findAllPerms: this.findAllPerms,
            findOne: this.findOne,
            update: this.update,
            delete: this.delete,
            save: this.save
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/role.js
// module id = 396
// module chunks = 0